import React, { useEffect, useState } from "react";

function DeviceSearch({ onSearch }) {
  const [value, setValue] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => onSearch(value), 200);
    return () => clearTimeout(timer);
  }, [value, onSearch]);

  return (
    <div className="device-search">
      <label htmlFor="device-search-input" className="sr-only">
        Search devices
      </label>
      <input
        id="device-search-input"
        type="text"
        placeholder="Search devices or brands…"
        value={value}
        onChange={(event) => setValue(event.target.value)}
      />
    </div>
  );
}

export default DeviceSearch;
